import { render, staticRenderFns } from "./SuggesDetail.vue?vue&type=template&id=f13590e4&scoped=true&"
import script from "./SuggesDetail.vue?vue&type=script&lang=js&"
export * from "./SuggesDetail.vue?vue&type=script&lang=js&"
import style0 from "./SuggesDetail.vue?vue&type=style&index=0&id=f13590e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f13590e4",
  null
  
)

export default component.exports